import app from "./config";
import { getAnalytics, logEvent, isSupported, setUserId, setUserProperties } from "firebase/analytics";

let analyticsInstance = null;

// Inisialisasi analytics hanya jika browser mendukung
(async () => {
  if (await isSupported()) {
    analyticsInstance = getAnalytics(app);
  }
})();

// Helper untuk log event custom
export const logAnalyticsEvent = (eventName, params) => {
  if (!analyticsInstance) return;
  logEvent(analyticsInstance, eventName, params);
};

// Helper untuk set userId
export const setAnalyticsUserId = (userId) => {
  if (!analyticsInstance) return;
  setUserId(analyticsInstance, userId);
};

// Opsional: helper untuk set user properties
export const setAnalyticsUserProps = (props) => {
  if (!analyticsInstance) return;
  setUserProperties(analyticsInstance, props);
};

export default analyticsInstance;
